import React from 'react';
import { findDOMNode } from 'react-dom';
import { Checkbox, Menu, Dropdown } from '@platform/base';
import { getSysFieldid, getGlobalStorage } from '@platform/api';
import { getCustomerColumnWidth } from '../../adapter/utils';
import classNames from 'classnames';

const MENU_ALL = "all";
const MENU_REVERSE = "reserve";
const MENU_PAGE = "page";
const COL_KEY_CHECKBOX = "CHECKBOX";

export default function useCheckbox(Table) {
    return class CheckboxTable extends React.Component {

        state = {
            checkBoxMenuShow: false,
            headCheckboxChecked: false,
        }

        render() {
            let { checkboxConfig = {}, columns = [], rows, locale, store } = this.props,
                { enable = false, checkedKeys = new Set(), onCheck, more, width = 45, disabledKeys = new Set(), mergeInfo } = checkboxConfig,
                { checkBoxMenuShow } = this.state;

            if (enable && columns.length) {
                let menuItems = (
                        <Menu onClick={this.handleCheckMenuClick}>
                            <Menu.Item key={MENU_ALL}>{locale['table0036'] /*全选*/}</Menu.Item>
                            <Menu.Item key={MENU_REVERSE}>{locale['table0039'] /*全反选*/}</Menu.Item>
                            <Menu.Item key={MENU_PAGE}>{locale['table0040'] /*仅当前页*/}</Menu.Item>
                        </Menu>
                    ),
                    checked = checkedKeys.size > 0 && rows.every(row => disabledKeys.has(row.key) || checkedKeys.has(row.key)),
                    indeterminate = !checked && checkedKeys.size > 0 && rows.some(row => disabledKeys.has(row.key) || checkedKeys.has(row.key));

                columns = [{
                    title:
                        <div
                            className='table-next-header-checkbox'
                            fieldid={getSysFieldid('firstcol')}
                        >
                            <Checkbox
                                className='table-next-checkbox'
                                tabIndex="-1"
                                disabled={rows.length && rows.every(row => disabledKeys.has(row.key))}
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={this.checkCurrentPage}
                            />
                            {more && <Dropdown overlay={menuItems} trigger={['click']} onVisibleChange={this.handleDropdownVisible}>
                                <i
                                    className={checkBoxMenuShow ? "iconfont icon-shangjiantou" : "iconfont icon-xiajiantou"}
                                />
                            </Dropdown>}
                        </div>,
                    key: COL_KEY_CHECKBOX,
                    width: width,
                    isleaf: true,
                    depth: 0,
                    fixed: 'left',
                    mergeInfo,
                    render: row => {
                        return <div
                            className='table-cell check-col'
                            fieldid={getSysFieldid('firstcol')}
                            // CheckBox 单元格点击事件与CheckBox选中事件保持一致
                            onClick={e => {
                                let checkedKey = row.key,
                                    checked = checkedKeys.has(checkedKey);
                                this.lastCheckedKey = this.lastCheckedKey || row.key;
                                // 阻止冒泡防止行点击触发
                                e.stopPropagation();

                                if (disabledKeys.has(checkedKey)) { return; }

                                if (checked) {
                                    checkedKeys.delete(checkedKey);
                                } else {
                                    if (e.shiftKey) {
                                        let startIndex,
                                            endIndex,
                                            visibleRows = store.getVisibleRows();
                                        visibleRows.forEach(row => {
                                            let rowKey = row.rowId || row.rowid || row.key;
                                            if (rowKey === checkedKey || rowKey === this.lastCheckedKey) {
                                                if (startIndex === undefined) {
                                                    startIndex = row.viewIndex;
                                                } else {
                                                    endIndex = row.viewIndex;
                                                }
                                            }
                                            if ((row.viewIndex >= startIndex && !endIndex) || row.viewIndex <= endIndex) {
                                                checkedKeys.add(rowKey);
                                            }
                                        });
                                    } else {
                                        checkedKeys.add(checkedKey);
                                    }
                                }
                                this.lastCheckedKey = checkedKey;
                                onCheck(checkedKey, { isChecked: !checked, checkedKeys });
                            }
                            }
                            onClickCapture={e => {
                                if (e.ctrlKey) {
                                    e.stopPropagation();
                                }
                            }}
                        >
                            <Checkbox
                                className='table-next-checkbox'
                                disabled={disabledKeys.has(row.key)}
                                checked={checkedKeys.has(row.key)}
                                onChange={value => {
                                    let checkedKey = row.key;
                                    if (value) {
                                        if (this.checkBoxShiftKey) {
                                            let startIndex,
                                                endIndex,
                                                visibleRows = store.getVisibleRows();
                                            visibleRows.forEach(row => {
                                                let rowKey = row.rowId || row.rowid || row.key;
                                                if (rowKey === checkedKey || rowKey === this.lastCheckedKey) {
                                                    if (startIndex === undefined) {
                                                        startIndex = row.viewIndex;
                                                    } else {
                                                        endIndex = row.viewIndex;
                                                    }
                                                }
                                                if ((row.viewIndex >= startIndex && !endIndex) || row.viewIndex <= endIndex) {
                                                    checkedKeys.add(rowKey);
                                                }
                                            });
                                        } else {
                                            checkedKeys.add(checkedKey);
                                        }
                                    } else {
                                        checkedKeys.delete(checkedKey);
                                    }
                                    this.lastCheckedKey = checkedKey;
                                    onCheck?.(checkedKey, { isChecked: value, checkedKeys });
                                }}
                                tabIndex="-1"
                                onClick={e => {
                                    this.lastCheckedKey = this.lastCheckedKey || row.key;
                                    this.checkBoxShiftKey = e.shiftKey;
                                    e.stopPropagation();
                                }

                                } // TODO:确认一下和rowClick是否冲突
                            />
                        </div>;
                    },
                },
                ...columns,
                ];
            }

            return (
                <Table {...this.props} columns={columns} />
            );
        }

        handleCheckMenuClick = ({ key }) => {
            let { checkboxConfig, allRowsInfo, rows, pkname, store } = this.props,
                { childPkName } = store.getConfig(),
                { allpks, allbodypks } = allRowsInfo,
                { onCheck, checkedKeys = new Set(), allCheckedKeys = new Set(), allBodyCheckedKeys } = checkboxConfig,
                isCheckedAll = false;

            if (!allpks?.length) {
                console.warn('没有配置allpks');
                return;
            }

            switch (key) {
                case MENU_ALL:
                    checkedKeys = new Set(rows.map(e => e.key));
                    allCheckedKeys = new Set(allpks);
                    allBodyCheckedKeys = new Set(allbodypks);
                    isCheckedAll = true;
                    break;
                case MENU_REVERSE:
                    checkedKeys = new Set(rows.filter(e => !checkedKeys.has(e.key)).map(e => e.key));
                    allCheckedKeys = new Set(allpks.filter(pk => !allCheckedKeys.has(pk)));
                    allBodyCheckedKeys = new Set(allbodypks.filter(pk => !allBodyCheckedKeys.has(pk)));
                    break;
                case MENU_PAGE:
                    checkedKeys = new Set(rows.map(e => e.key));
                    allCheckedKeys = new Set(rows.map(row => {
                        let values = row.values || row;
                        return values[pkname].value;
                    }));
                    allBodyCheckedKeys = new Set(rows.map(row => {
                        let values = row.values || row;
                        return values[childPkName]?.value;
                    }));
                    break;
                default:
                    break;
            }

            onCheck?.('', { isChecked: true, checkedKeys, allCheckedKeys, allBodyCheckedKeys, isCheckedAll });
            this.setState({ checkBoxMenuShow: false });
        }

        handleDropdownVisible = value => {
            this.setState({ checkBoxMenuShow: value });
        }

        checkCurrentPage = value => {
            let { rows, checkboxConfig, pkname, crossPageSelect, store } = this.props,
                { childPkName } = store.getConfig(),
                { onCheck, allCheckedKeys = new Set(), allBodyCheckedKeys = new Set() } = checkboxConfig,
                { tableType } = store.getFlatInfo?.() || {},
                checkedKeys;

            if (value) {
                // 全选
                checkedKeys = new Set(rows.map(e => e.key));
                pkname && crossPageSelect && rows.forEach(row => {
                    let values = row.values || row;
                    allCheckedKeys.add(values[pkname].value);
                    if (tableType === "flat") {
                        allBodyCheckedKeys.add(values[childPkName]?.value);
                    }
                });
            } else {
                // 全消
                checkedKeys = new Set();
                pkname && crossPageSelect && rows.forEach(row => {
                    let values = row.values || row;
                    allCheckedKeys.delete(values[pkname].value);
                    if (tableType === "flat") {
                        allBodyCheckedKeys.delete(values[childPkName]?.value);
                    }
                });
            }
            onCheck?.('', {
                isChecked: value,
                checkedKeys,
                allCheckedKeys: pkname && allCheckedKeys,
                allBodyCheckedKeys: pkname && allBodyCheckedKeys,
            });
        }
    };
}

const DEFAULT_INFO = { checkedKeys: new Set(), disabledKeys: new Set(), allCheckedKeys: new Set(), allBodyCheckedKeys: new Set() };

// TODO:获取checkedKeys时拷贝，防止修改引用，拿不到旧的checkedKeys
useCheckbox.displayName = 'useCheckbox';
useCheckbox.dependence = [];
useCheckbox.hooks = function () {
    this.store.checkedInfo = {};
    return {
        getDisabledKeys: () => {
            return new Set(this.store.checkedInfo?.disabledKeys || new Set());
        },
        setDisabledKeys: (keys, { shouldUpdate = true } = {}) => {
            this.store.checkedInfo.disabledKeys = new Set(keys);
            shouldUpdate && this.forceUpdate();
        },
        getCheckedKeys: () => {
            return new Set(this.store.checkedInfo?.checkedKeys || new Set());
        },
        // isCheckedAll是个状态，兼容之前的设计
        setCheckedKeys: (keys, { shouldUpdate = true, isCheckedAll, skipDisabled = false } = {}) => {
            let { disabledKeys = new Set(), checkedKeys = new Set(), allCheckedKeys = new Set(), allBodyCheckedKeys = new Set() } = this.store.checkedInfo || {},
                { childToParent = {} } = this.store.pkRelationMap || {},
                { tableType } = this.getFlatInfo?.() || {},
                { crossPageSelect, pkname, childPkName } = this.store.componentConfig || {};

            !keys && (keys = new Set());
            keys = new Set([...keys].filter(key => !disabledKeys.has(key)));

            if (skipDisabled) {
                // 用户点击时跳过disabled
                // 禁用并且选中状态的保持
                [...disabledKeys].forEach(key => {
                    if (checkedKeys.has(key)) {
                        keys.add(key);
                    }
                });
            } else {
                // api调用时操作disabled
                // 禁用的能删，不能增
                disabledKeys.forEach(key => {
                    keys.delete(key);
                });
            }

            // 更新allCheckedKeys（跨页选）
            if (crossPageSelect && pkname) {
                keys.forEach(key => {
                    if (!checkedKeys.has(key)) { //没选中的行给加上
                        let row = this.getRowData(key),
                            values = row.values || row;
                        allCheckedKeys.add(values[pkname].value);
                        if (tableType === "flat") {
                            allBodyCheckedKeys.add(values[childPkName]?.value);
                        }
                    }
                });

                checkedKeys.forEach(key => { //选中的行取消掉
                    if (!keys.has(key)) {
                        let row = this.getRowData(key);

                        if (!row) { return; }

                        let values = row.values || row;

                        allCheckedKeys.delete(values[pkname].value);
                        if (tableType === "flat") {
                            allCheckedKeys.clear(); //重新构造一下allCheckedKeys
                            allBodyCheckedKeys.delete(values[childPkName]?.value);
                            allBodyCheckedKeys.forEach(bodypk => {
                                allCheckedKeys.add(childToParent[bodypk]);
                            });
                        }
                    }
                });

                this.store.checkedInfo.allCheckedKeys = allCheckedKeys;
                this.store.checkedInfo.allBodyCheckedKeys = allBodyCheckedKeys;
            }

            this.store.checkedInfo.checkedKeys = keys;
            this.store.checkedInfo.isCheckedAll = isCheckedAll;
            
            setTimeout(() => {
                let TableInstance = this.getComponent('Table')?.current;
                if(keys.size === 1 && TableInstance) {
                    let TableDOM = findDOMNode(TableInstance),
                        rowDOM = TableDOM.querySelector(`tr[rowkey='${[...keys][0]}']`),
                        checkedTotalDOM = TableDOM.querySelector('#checked-total-row');
                    if(checkedTotalDOM) {
                        let { top:checkedTotalTop } = checkedTotalDOM.getBoundingClientRect();
                        let { top:rowTotalTop, height:rowHeight } = rowDOM.getBoundingClientRect();
                        if(rowTotalTop > checkedTotalTop - rowHeight) {
                            rowDOM.scrollIntoView({ block:'end' });   
                        }
                    }
                }
            });
             
            // 合计行有一个allowTotalRows属性，一般和checkbox配合
            // 暂时先这么写，有其他场景再补充
            this._updateTotal();
            shouldUpdate && this.forceUpdate();
        },
        getAllCheckedKeys: () => {
            return new Set(this.store.checkedInfo.allCheckedKeys || new Set());
        },
        // isCheckedAll是个状态，兼容之前的设计
        setAllCheckedKeys: (keys, { isCheckedAll, shouldUpdate = true } = {}) => { //主表调用这个设置
            let { disabledKeys = new Set() } = this.store.checkedInfo || {},
                { crossPageSelect, pkname } = this.store.componentConfig;
            if (crossPageSelect && pkname) {
                let disabledPks = new Set([...disabledKeys].filter(key => !!this.getRowData(key)).map(key => {
                    let row = this.getRowData(key),
                        values = row.values || row;
                    return values[pkname]?.value;
                }));
                this.store.checkedInfo.allCheckedKeys = new Set([...keys].filter(pk => !disabledPks.has(pk)));
                this.store.checkedInfo.isCheckedAll = isCheckedAll;
            }
            shouldUpdate && this.forceUpdate();
        },
        getAllBodyCheckedKeys: () => {
            return new Set(this.store.checkedInfo.allBodyCheckedKeys || new Set());
        },
        setAllBodyCheckedKeys: (keys, { isCheckedAll, shouldUpdate = true } = {}) => { //子表调用这个设置
            let { tableType } = this.getFlatInfo?.() ?? {};
            if (tableType !== "flat") { return; }
            
            let { disabledKeys = new Set() } = this.store.checkedInfo || {},
                { childToParent } = this.store.pkRelationMap || {},
                relationAllCheckedKeys = new Set(),
                { crossPageSelect, pkname, childPkName } = this.store.componentConfig;
            
            if (crossPageSelect && pkname && childToParent) {
                let disabledChildPks = new Set([...disabledKeys].filter(key => !!this.getRowData(key)).map(key => {
                    let row = this.getRowData(key),
                        values = row.values || row;
                    return values[childPkName]?.value;
                }));
                this.store.checkedInfo.allBodyCheckedKeys = new Set([...keys].filter(pk => !disabledChildPks.has(pk)));
                //主子表模式下,维护子表的bodyCheckedKeys,但领域还是需要主表pk,所以最后统一设置下
                this.store.checkedInfo.allBodyCheckedKeys.forEach(key => relationAllCheckedKeys.add(childToParent[key]));
                this.setAllCheckedKeys(relationAllCheckedKeys, { isCheckedAll });
            }
            
            shouldUpdate && this.forceUpdate();
        },
        getCheckedInfo: () => {
            let mergedInfo = { ...DEFAULT_INFO, ...this.store.checkedInfo };

            mergedInfo.checkedKeys = new Set(mergedInfo.checkedKeys);
            mergedInfo.allCheckedKeys = new Set(mergedInfo.allCheckedKeys);
            mergedInfo.allBodyCheckedKeys = new Set(mergedInfo.allBodyCheckedKeys);

            return mergedInfo;
        },
        setCheckedInfo: info => {
            return this.store.checkedInfo = info || { ...DEFAULT_INFO };
        },
        clearCheckedInfo: () => {
            this.store.checkedInfo = { checkedKeys: new Set(), disabledKeys: new Set(), allCheckedKeys: new Set(), allBodyCheckedKeys: new Set() };
        },
        checkAll: () => {
            let rows = this.getVisibleRows(),
                { allpks, allbodypks } = this.getAllRowsInfo();

            rows && this.setCheckedKeys(new Set(rows.map(row => row.key)));
            allpks && this.setAllCheckedKeys(new Set(allpks));
            allbodypks && this.setAllBodyCheckedKeys(new Set(allbodypks));
        },
        checkReverse: () => {
            let { checkedKeys = new Set(), allCheckedKeys = new Set(), allBodyCheckedKeys } = this.store.checkedInfo || {};

            let rowKeys = this.getVisibleRowKeys(),
                { allpks, allbodypks } = this.getAllRowsInfo();

            this.setCheckedKeys(new Set(rowKeys.filter(key => !checkedKeys.has(key))));
            this.setAllCheckedKeys(new Set(allpks.filter(pk => !allCheckedKeys.has(pk))));
            this.setAllBodyCheckedKeys(new Set(allbodypks.filter(pk => !allBodyCheckedKeys.has(pk))));
        },
        checkCurrentPage: () => {
            let rowKeys = this.getVisibleRowKeys();

            this.setCheckedKeys(rowKeys);
        },
        // isCheckedAll是个状态，兼容之前的设计
        isAllChecked: () => {
            return this.store.checkedInfo.isCheckedAll;
        },
        isCurrentPageAllChecked: () => {
            let { checkedKeys = new Set() } = this.store.checkedInfo || {},
                rows = this.getVisibleRows();

            if (!checkedKeys.size || !rows?.length || checkedKeys.size !== rows.length) { return false; }

            return rows.every(row => checkedKeys.has(row.key));
        },
        setLastCheckedKey: rowKey => {
            let info = { ...DEFAULT_INFO, ...this.store.checkedInfo };
            this.store.checkedInfo = { ...info, lastCheckedKey: rowKey };
        },
        getLastCheckedKey: () => {
            return this.store.checkedInfo?.lastCheckedKey;
        },
    };
};
useCheckbox.propsGenerator = function (props) {
    // enable为false时只是不显示复选框，但勾选事件还是要触发
    // if(!checkboxConfig?.enable){
    //     return props;
    // }

    const { checkboxConfig, store, id, rowProps } = props,
        checkedInfo = store.getCheckedInfo(),
        { crossPageSelect, pkname } = store.getConfig() || {};

    const onCheck = (rowKey, { isChecked, checkedKeys, allCheckedKeys, isCheckedAll, allBodyCheckedKeys } = {}) => {
        let lastCheckedKeys = store.getCheckedKeys();
        store.setCheckedKeys(checkedKeys, { isCheckedAll, skipDisabled: true });
        if (crossPageSelect && pkname) {
            if (allCheckedKeys) {
                store.setAllCheckedKeys(allCheckedKeys, { isCheckedAll, skipDisabled: true });
                store.setAllBodyCheckedKeys(allBodyCheckedKeys, { isCheckedAll, skipDisabled: true });
            }
        }

        if (rowKey && isChecked) {
            store.setLastCheckedKey(rowKey);
        }

        checkboxConfig?.onCheck?.(rowKey, { isChecked, checkedKeys, lastCheckedKeys });
    };

    return {
        ...props,
        checkboxConfig: {
            ...checkboxConfig,
            ...checkedInfo,
            width: getCustomerColumnWidth(store, id, COL_KEY_CHECKBOX, 45),
            onCheck,
        },
        rowProps: (row, viewIndex) => {
            let rawRowProps = rowProps?.(row, viewIndex) ?? {},
                { disableClickRowToSelect, disableClickCellToSelectProps } = rawRowProps,
                status = store.getStatus(),
                { crossPageSelect, pkname, childPkName } = store.getConfig() || {};
            rawRowProps.className = classNames(rawRowProps.className, {
                'checked-row': checkboxConfig?.enable && checkedInfo.checkedKeys.has(row.key),
                'select-disabled': checkedInfo.disabledKeys.has(row.key),
            });
            return disableClickRowToSelect ? rawRowProps : {
                ...rawRowProps,
                onClick: event => {
                    if (disableClickCellToSelectProps?.some(props => Object.keys(props).every(key => event.target[key] === props[key]))) {
                        return;
                    }
                    if (status === 'browse' && !store.getConfig()?.gridType) { // 卡片表格不需要点击选中
                        let rowKey = row.key,
                            checkedKeys = store.getCheckedKeys(),
                            disabledKeys = store.getDisabledKeys(),
                            isClickCheck = checkedKeys.size === 1 && checkedKeys.has(rowKey);

                        if (!disabledKeys.has(rowKey)) {

                            let allCheckedKeys = null, allBodyCheckedKeys, checkedKeys = isClickCheck ? [] : [rowKey];
                            if (crossPageSelect && pkname) {
                                allCheckedKeys = checkedKeys.map(key => store.getRowData(key)?.values?.[pkname]?.value ?? '');
                                allBodyCheckedKeys = checkedKeys.map(key => store.getRowData(key)?.values?.[childPkName]?.value ?? '');
                            }
                            if (event.target.localName !== 'a' && event.target.className !== 'code-detail-link') {//点击a标签不选中行 参考旧代码实现
                                if (event._targetInst?.pendingProps?.fieldid === "switch" && getGlobalStorage('localStorage', '_ncc_automated_') === '1') { //影响自动化测试，后续看情况是否放开
                                    isClickCheck = false;
                                    checkedKeys = [rowKey];
                                }
                                {
                                    onCheck(rowKey, {
                                        isChecked: !isClickCheck,
                                        checkedKeys: new Set(checkedKeys),
                                        allCheckedKeys: allCheckedKeys && new Set(allCheckedKeys),
                                        allBodyCheckedKeys: allBodyCheckedKeys && new Set(allBodyCheckedKeys),
                                    });
                                }
                            }
                        }
                    }
                    rawRowProps?.onClick?.(event);
                },

            };
        },
        cellProps: (rowInfo, colInfo) => {
            let rawCellProps = props.cellProps?.(rowInfo, colInfo) || {};
            return colInfo.col.key === COL_KEY_CHECKBOX ? {
                ...rawCellProps,
                onDoubleClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                },
            } : rawCellProps;
        },
    };
};